import { render, staticRenderFns } from "./SNotification.vue?vue&type=template&id=78218f50&scoped=true&"
import script from "./SNotification.vue?vue&type=script&lang=js&"
export * from "./SNotification.vue?vue&type=script&lang=js&"
import style0 from "./SNotification.vue?vue&type=style&index=0&id=78218f50&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78218f50",
  null
  
)

export default component.exports